<template>
	<div class="col-12">
		<div class="card card-outline card-navy">
			<div class="card-header">
				<h3 class="card-title">Lista de Pagos de Dividendos</h3>
				<div class="card-tools">
					<!-- <button @click="downloadFiles()" class="btn btn-sm btn-outline-secondary mr-1">
						<i class="fa-solid fa-box-archive"></i> Archivo de Nóminas
					</button> -->
					<button class="btn btn-outline-success btn-sm mr-2" v-can="'export_share'"
						@click="exportData()">
						<i class="fa fa-file-excel"></i> Exportar
					</button>
				</div>
			</div>
			<div class="card-body">
				<div class="row">
					<div class="col-md-7 col-lg-8">
						<label>Buscar :</label>
						<input class="form-control" v-debounce:2s="list" type="search" v-model="search_all">
					</div>
					<div class="col-md-5 col-lg-4">
						<label>Rango de fechas :</label>
						<date-picker format="YYYY-MM-DD" valueType="format" :range="true"
							v-model="search.date"></date-picker>
						<div v-if="init" class="text-danger">Periodo por Defecto</div>
					</div>
					<div class="col-md-4 mt-2">
						<label>Empresa :</label>
						<select v-model="search.company_id" class="form-control">
							<option value=""> Sin empresa </option>
							<option v-for="(company, index) in companies" :value="company.id" :key="index">
								{{ company.name }}</option>
						</select>
					</div>
					<div class="col-md-4 mt-2">
						<label>Socio :</label>
						<select type="text" class="form-control" v-model="search.user_id">
							<option value="">Todos</option>
							<option v-for="(user, index) in catalogue.users_profile" :value="user.id" :key="index">
								{{ user.name }} {{ user.last_name }}</option>
						</select>
					</div>
					<div class="col-md-4 mt-2">
						<label>Tipo de pago</label>
						<select type="text" class="form-control" v-model="search.type_payment_id">
							<option value="">Todos</option>
							<option v-for="(type_payment, index_type_payment) in catalogue.type_payments"
								:value="type_payment.id" :key="index_type_payment">{{
									type_payment.name }}</option>
						</select>
					</div>
				</div>
				<br>
				<div class="row">
					<div class="col-md-12">
						<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
							<li class="nav-item">
								<a class="nav-link active" @click="search.paid = 0" data-toggle="pill" role="tab"
									aria-selected="true">Por pagar</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click="search.paid = 1" data-toggle="pill" role="tab"
									aria-selected="false">Pagados</a>
							</li>
						</ul>
					</div>
				</div>
				<div class="table-responsive">
					<table class="table table-bordered text-sm text-center">
						<thead>
							<tr>
								<th>ID</th>
								<th style="width: 45%;">Datos</th>
								<th style="width: 140px;">Monto</th>
							<!--	<th style="width: 140px;">Por pagar</th> -->
								<th style="width: 140px;">Pagado</th>
								<th>Fecha de aprobación</th>
							<!--	<th>Fecha de creación</th> -->
								<th>Fecha de reparto</th>
								<th class="text-center">Opciones</th>
								<th v-can="'add_pays_fast'" v-if="paymentConditions()" class="text-center">
									<button class="btn btn-sm btn-info" @click="selectAll">
										<i class="fa-solid fa-check-double"></i>
									</button>
								</th>
								<th v-can="'add_pays_fast'" v-if="paymentConditionsCheck()" class="text-center">
									<button class="btn btn-sm btn-info" @click="selectAll">
										<i class="fa-solid fa-check-double"></i>
									</button>
								</th>
							</tr>
						</thead>
						<tbody v-if="load">
							<tr>
								<td align="center" colspan="10">
									<i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
									<h5>Cargando</h5>

								</td>
							</tr>
						</tbody>
						<tbody v-else-if="checks.total > 0">
							<tr v-for="(check, index) in checks.data" :key="index">
								<td>{{ check.id }}</td>
								<td class="text-left">
									<!-- Tipo -->
									<!-- Nomina -->
									<span v-if="check.share_id">
										<strong>Socio : </strong>
										<span v-if="check.user&&(authUser.organization_charts_id==1 || authUser.companies.some((spec, index) => { return spec.id == check.share.company_id }))">{{check.user.name}} {{check.user.last_name}}</span>
										<span v-else-if="check.user">XXXXXXXXXXX</span>
										<span v-else>Sin usuario</span>
										<span v-if="(user=check.share.users.filter((user, index) => { return (user.id == check.user_id)})[0]) && (bank = check.user.bank_accounts.filter((bank, index) => { return (user.pivot.bank_account_id == bank.id)})[0])">
										<br>
											<strong>Cuenta bancaria: </strong>
											<span v-if="authUser.organization_charts_id==1 || authUser.companies.some((spec, index) => { return spec.id == check.share.company_id })">{{bank.account_number }}</span>
											<span v-else>XXXXXXXXXXX</span>
										</span>
										<!-- <span v-else>No Aplica</span> -->
										<br>
										<strong>Compañía : </strong>
										{{ check.share.company.name }}<br>
										<strong>Fecha : </strong>
										{{ check.share.date | toDateTime }}<br>
										
										<strong>Tipo de Pago : </strong>
										<span v-if="check.type_payment">
											{{ check.type_payment.name }}
										</span>
										<span v-else>Sin tipo</span>
										<br>
										<strong>Monto : </strong>
										{{ check.share.amount | toCurrency }}<br>
									</span>
								</td>
								<td class="text-right">
									{{ (check.amount + check.credit) | toCurrency }}
								</td>
							<!--	<td class="text-right">
									<strong style="font-weight: 900;">{{ check.amount_payable | toCurrency }}</strong>
								</td> -->
								<td class="text-right">
									{{ check.sum_pays | toCurrency }}
								</td>
								<td>
									<span v-if="check.user_approved"> {{ check.authorization_date | toDateTime }} </span>
									<span v-else>Sin Fecha</span>
								</td>
							<!--	<td>
									{{ check.created_at | toDateTime }}
								</td> -->
								<td>
									<span v-if="check.share">
										{{ check.share.date | toDateTime }}
									</span>
									<span v-else>
										S/F
									</span>

								</td>
								<td class="text-center">
									<!-- <button v-if="check.share&&check.type_payment && check.type_payment.name=='Dispersión'&&(authUser.organization_charts_id==1 || authUser.companies.some((spec, index) => { return spec.id == check.share.company_id }))" @click="showShare(check.share)"
										class="btn btn-outline-secondary m-1 btn-sm">
										<i class="fa-solid fa-receipt mr-1"></i> Ver reparto
									</button> -->

									<div class="d-inline" v-if="check.pay.length == 0">
										<button v-if="check.share_id && check.type_payment_id != 6"
											@click="formDataPayFast(check)"
											class="btn btn-outline-secondary m-1 btn-sm">
											<i class="fa-solid fa-receipt mr-1"></i> Pago rápido
										</button>

										<button v-if="check.share_id && check.type_payment_id == 6"
											@click="formDataPaysFastCheckbook(check)"
											class="btn btn-outline-secondary m-1 btn-sm">
											<i class="fa-solid fa-receipt mr-1"></i> Pago rápido cheque
										</button>
									</div>

									<button type="button" v-if="check.share_id" @click="deleted(check.id)"
										v-can="'deleted_checks'" class="btn-outline-danger btn m-1 btn-sm ">
										<i class="fa fa-trash"></i> Eliminar
									</button>
									<button @click="formListPays(check)" class="btn m-1 btn-sm btn-outline-warning">
										<i class="fa-solid fa-hand-holding-dollar mr-1"> </i>
										<span>Ver pago</span>
									</button>

								</td>
								<th class="text-center" v-can="'add_pays_fast'" v-if="paymentConditions()">
									<input type="checkbox" :disabled="check.type_payment_id == 6"
										class="form-control form-control-sm" :value="check.id" v-model="Arrauthorized">																		
								</th>
								<th class="text-center" v-can="'add_pays_fast'" v-if="paymentConditionsCheck()">
									<input type="checkbox" :disabled="check.type_payment_id != 6"
										class="form-control form-control-sm" :value="check.id" v-model="Arrauthorized">
									<br>
									<span v-if="check.checkbook" class="badge badge-info">
									{{ check.checkbook.name }}
									<br>-<br>
									{{ check.folio_prev }}
									</span>
								</th>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td align="center" colspan="10">Sin resultados.</td>
							</tr>
						</tbody>
						<tfoot v-if="checks.total > 0 && load == false">
							<tr class="table-secondary">
								<td colspan="2">
									Total :
								</td>
								<td class="text-right">
									{{ sumdata()[0] | toCurrency }}
								</td>
								<!-- <td class="text-right">
									{{ sumdata()[1] | toCurrency }}
								</td> -->
								<td class="text-right">
									{{ sumdata()[2] | toCurrency }}
								</td>
								<td colspan="3"></td>
							</tr>
						</tfoot>
					</table>
					<pagination v-if="checks" v-model="page" :records="checks?checks.total:0" :per-page="checks?checks.per_page:0"
						@paginate="list" />
				</div>
				<div class="row mt-3" v-can="'add_pays_fast'" v-if="paymentConditions()">
					<div class="col-12 text-right">
						<button class="btn btn-outline-info" v-if="!sendGroup" @click="formDataPaysFastGroup()">
							<i class="fa-solid fa-list-check"></i> Pago rápido
							seleccionado
						</button>
						<button class="btn btn-outline-info" v-else>
							<i class="fa-solid fa-circle-notch fa-spin"></i> Pagando
						</button>
					</div>
				</div>

				<div class="row mt-3" v-can="'add_pays_fast'" v-if="paymentConditionsCheck()">
					<div class="col-12 text-right">
						<button class="btn btn-outline-info" v-if="!sendGroup" @click="formDataPaysFastGroupCheck()">
							<i class="fa-solid fa-list-check"></i> Pago de cheque agrupado
						</button>
						<button class="btn btn-outline-info" v-else>
							<i class="fa-solid fa-circle-notch fa-spin"></i> Pagando
						</button>
					</div>
				</div>

			</div>
		</div>

		<ModalTableComponentPays :prop_edit="false" />
		<LoadPay />
		<ModalFormComponentPartner :prop_edit="false" />
		<ModalPayCheckbookFastComponent />
		<ModalPayGroupCheckbookFastComponent />
		<ModalDownloadFileComponent />
	</div>
</template>



<script>
import ModalTableComponentPays from '@/components/pays/ModalTableComponent.vue';
import ModalFormComponentPartner from '@/components/partner/ModalFormComponent.vue';
import ModalDownloadFileComponent from '@/components/partner/ModalDownloadFileComponent.vue';
import ModalPayCheckbookFastComponent from '@/components/pays/ModalPayCheckbookFastComponent.vue';
import ModalPayGroupCheckbookFastComponent from '@/components/pays/ModalPayGroupCheckbookFastComponent.vue';

import LoadPay from '@/components/LoadPayPageComponent.vue';

import { mapMutations, mapActions, mapGetters } from 'vuex';
import Pagination from 'vue-pagination-2';
import request from '@/services/request';
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
	name: "pays-partners-table",
	components: {
		ModalTableComponentPays,
		LoadPay,
		Pagination,
		DatePicker,
		ModalDownloadFileComponent,
		ModalFormComponentPartner,
		ModalPayCheckbookFastComponent,
		ModalPayGroupCheckbookFastComponent
	},
	data() {
		return {
			Arrauthorized: [],
			sendGroup: false,
			checks: [],
			name: '',
			trigger:true,
			init:false,
			search: {
				date: '',
				company_id: '',
				search: '',
				user_id: '',
				type_payment_id: '',
				share: 1,
				paid:0,
			},
			search_all: '',
			page: 1,
			catalogue: new Catalogue(),
			load: false,
			companies:null,
			users:null,
			type_payments:null,
		}
	},
	mounted() {
		if(this.authUser.organization_charts_id == 10 || this.authUser.organization_charts_id == 15){ 
            this.catalogue.get_companies_users(this.authUser.id);
        }else{
            this.catalogue.get_companies_buildings();
        }
		this.catalogue.get_users_profile(8);
		this.catalogue.get_type_payments();
		this.list();
		this.setHeaderTitle('Pagos Socios');
	},
	created() {
		Event.$on("event-load-checks", () => {
			this.list();
		});
	},
	methods: {
		formDataPaysFastGroupCheck() {
			Event.$emit('event-show-showPayGroupCheckbookFast', this.search, this.checks.data);
		},
		showShare(share) {
			Event.$emit('event-show-addShare', share);
		},
		sumdata() {
			let sum1 = 0;
			let sum2 = 0;
			let sum3 = 0;
			if (this.checks) {
				this.checks.data.forEach(function (buy) {
					if (buy.amount) {
						sum1 += parseFloat(buy.amount);
					}
					if (buy.credit) {
						sum1 += parseFloat(buy.credit);
					}
					sum2 += parseFloat(buy.amount_payable);
					sum3 += parseFloat(buy.sum_pays);

				});
			}

			return [sum1, sum2, sum3];
		},
		selectAll() {
			this.Arrauthorized = [];
			let selected = this.Arrauthorized;
			this.checks.data.forEach(element => {
				if (!selected.includes(element.id)) {
					selected.push(element.id);
				}
			});
			this.Arrauthorized = selected;
		},
		exportData() {
			Event.$emit('event-show-downloadFile');
		},
		paymentConditions() {
			return this.search.company_id != '' &&
				(this.search.date == '' || this.search.date[0]==null) &&
				this.search.search == '' &&
				this.search.user_id == '' &&
				this.search.type_payment_id == ''
		},
		paymentConditionsCheck() {
			return this.search.company_id != '' &&
				this.search.type_payment_id == 6 &&
				this.search.user_id == '' &&
				(this.search.date == '' || this.search.date[0]==null) &&
				this.search.search == ''
		},
		formListPays(check) {
			Event.$emit('event-show-listPays', check);
		},
		async formDataPaysFastCheckbook(check) {
			Event.$emit('event-show-addPayCheckbookFast', check);
		},
		async formDataPayFast(check) {
			let company_id = check.share.company_id;
			await this.catalogue.getBankAccountCompany(company_id);
			let bancks = this.catalogue.bank_account_company;
			let banco = [];
			bancks.forEach(function (bank) {
				let name = '';
				if (bank.bank) {
					name += bank.bank.name + ' - ';
				}
				name += bank.number;
				banco['_' + bank.id] = name;
			});

			if (bancks.length == 0) {
				this.$swal({
					title: "No se cuenta con cuenta",
					text: "No se puede pagar es requerida una cuenta",
					icon: "info"
				});
			}

			if (bancks.length > 1) {
				const { value: bank_id } = await this.$swal({
					title: "Cuenta de banco",
					html: '<div class="col-12"><input type="date" id="input_date_12" class="form-control"></div>',
					input: "select",
					inputOptions: banco,
					inputPlaceholder: "Seleccione una cuenta de banco",
					showCancelButton: true,
					inputValidator: (value) => {
						console.log(value);
						return new Promise((resolve) => {
							let date = document.getElementById('input_date_12').value;
							if (value !== "" && date !== "") {
								resolve();
							} else {
								if (value == "") {
									resolve("Es requerida la cuenta de banco");
								} else {
									resolve("Es requerida la fecha");
								}
							}
						});
					}
				});

				if (bank_id) {
					this.$modal.show('LoadPay');
					this.sendGroup = true;
					let form = {
						check_id: check.id,
						bank_id: bank_id.substring(1),
						date: document.getElementById('input_date_12').value,
					};
					let _endpoint = '/partners/pay_share';
					try {
						let { data } = await request.post(_endpoint, form)
						if (data) {
							console.log(data);
							this.successNotification(data.message);
							this.list();
							Event.$emit('event-show-addShare');
							this.sendGroup = false;

						}
					} catch (error) {
						this.errors = {};
						if (error.response) {
							this.errors = await this.errorNotification(error);
							this.sendGroup = false;
						}
					}
					this.$modal.hide('LoadPay');
				}
			} else {
				this.$swal({
					title: 'Pago rápido',
					html: 'Se aprobará el pago rápido<br><br><input type="date" id="input_date_2" class="form-control">',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Pagar',
					cancelButtonText: 'Cancelar'
				}).then(async (result) => {
					if (result.isConfirmed) {
						this.$modal.show('LoadPay');
						this.sendGroup = true;
						let form = {
							check_id: check.id,
							bank_id: bancks[0].id,
							date: document.getElementById('input_date_2').value,
						};
						let _endpoint = '/partners/pay_share';
						try {
							let { data } = await request.postMedia(_endpoint, form)
							if (data) {
								console.log(data);
								this.successNotification(data.message);
								this.list();
								Event.$emit('event-show-addShare');
								this.sendGroup = false;
							}
						} catch (error) {
							this.errors = {};
							if (error.response) {
								this.errors = await this.errorNotification(error);
								this.sendGroup = false;

							}
						}
						this.$modal.hide('LoadPay');
					}
				});
			}

		},
		async formDataPaysFastGroup() {
			let company_id = this.search.company_id;
			let Arrauthorized = this.Arrauthorized;
			await this.catalogue.getBankAccountCompany(company_id);
			let bancks = this.catalogue.bank_account_company;
			let banco = [];
			bancks.forEach(function (bank) {
				let name = '';
				if (bank.bank) {
					name += bank.bank.name + ' - ';
				}
				name += bank.number;
				banco['_' + bank.id] = name;
			});

			if (bancks.length == 0) {
				this.$swal({
					title: "No se cuenta con cuenta",
					text: "No se puede pagar es requerida una cuenta",
					icon: "info"
				});
			}

			if (bancks.length > 1) {
				const { value: bank_id } = await this.$swal({
					title: "Cuenta de banco",
					html: '<div class="col-12"><input type="date" id="input_date_12" class="form-control"></div>',
					input: "select",
					inputOptions: banco,
					inputPlaceholder: "Seleccione una cuenta de banco",
					showCancelButton: true,
					inputValidator: (value) => {
						console.log(value);
						return new Promise((resolve) => {
							let date = document.getElementById('input_date_12').value;
							if (value !== "" && date !== "") {
								resolve();
							} else {
								if (value == "") {
									resolve("Es requerida la cuenta de banco");
								} else {
									resolve("Es requerida la fecha");
								}
							}
						});
					}
				});

				if (bank_id) {
					this.$modal.show('LoadPay');
					this.sendGroup = true;
					let form = {
						checks_id: Arrauthorized,
						bank_id: bank_id.substring(1),
						date: document.getElementById('input_date_12').value,
						description: 'Pago aprobado'
					};
					let _endpoint = '/pays_group';
					try {
						let { data } = await request.postMedia(_endpoint, form)
						if (data) {
							console.log(data);
							this.successNotification(data.message);
							this.list();
							Event.$emit('event-show-addShare');
							this.sendGroup = false;

						}
					} catch (error) {
						this.errors = {};
						if (error.response) {
							this.errors = await this.errorNotification(error);
							this.sendGroup = false;
						}
					}
					this.$modal.hide('LoadPay');
				}
			} else {

				this.$swal({
					title: 'Pago rápido',
					text: 'Se aprobara el pago rápido',
					html: '<input type="date" id="input_date_2" class="form-control">',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Pagar',
					cancelButtonText: 'Cancelar'
				}).then(async (result) => {
					if (result.isConfirmed) {
						this.$modal.show('LoadPay');
						this.sendGroup = true;
						let form = {
							checks_id: Arrauthorized,
							bank_id: bancks[0].id,
							date: document.getElementById('input_date_2').value,
							description: 'Pago aprobado'
						};
						let _endpoint = '/pays_group';
						try {
							let { data } = await request.postMedia(_endpoint, form)
							if (data) {
								console.log(data);
								this.successNotification(data.message);
								this.list();
								Event.$emit('event-show-addShare');
								this.sendGroup = false;
							}
						} catch (error) {
							this.errors = {};
							if (error.response) {
								this.errors = await this.errorNotification(error);
								this.sendGroup = false;

							}
						}
						this.$modal.hide('LoadPay');
					}
				});
			}
		},
		deleted: function (id) {
			let tit = 'Eliminar aprobación';
			let txt = 'Seguro que quiere eliminar la aprobación';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then((result) => {
				if (result.isConfirmed) {
					this.callDeleted(id);
				}
			});
		},
		async callDeleted(id) {
			let _endpoint = '/checks/' + id;
			try {
				let response = await request.destroy(_endpoint).then(function (response) { return response; });
				this.list();
				Event.$emit('event-show-addShare');
				this.successNotification(response.data.message);
			} catch (error) {
				this.errors = await this.errorNotification(error)
			}
		},
		async list(page = this.page) {
			this.init=false;
			this.checks = [];
			this.load = true;
			let service = request;
			let search = this.search;
			search.search = this.search_all;
			let _endpoint = '/pays';
			try {
				let { data } = await service.list(_endpoint, page, search)
				if (data) {
					this.init=this.search.company_id == '' &&
						this.search.type_payment_id == '' &&
						this.search.user_id == '' &&
						(this.search.date == '' || this.search.date[0]==null) &&
						this.search.search == '';
					this.checks = data.data;
					this.trigger=false;
					if(data.dates[0]!='')
						this.search.date = data.dates;
					else
						this.search.date = '';
					this.load = false;
					this.Arrauthorized = [];
				}
			} catch (error) {
				console.log(error);
				this.load = false;
			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			resetPassword: 'auth/resetPass',
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		}),
	},
	computed: {
		...mapGetters({
			'authUser': 'auth/user'
		})
	},
	watch: {
		'name': {
			handler: function (val) {
				if (val == '') {
					this.list();
				}
			},
			deep: true
		},
		'catalogue.companies_users': {
			handler: function () {
				this.companies=this.catalogue.companies_users;
			},
			deep: true
		},
		'catalogue.companies_buildings': {
			handler: function () {
				this.companies=this.catalogue.companies_buildings;
			},
			deep: true
		},
		"search": {
			handler: function () {
				this.page = 1;
				if(this.trigger)
					this.list();
				else
					this.trigger=true;
			},
			deep: true
		}
	}
}
</script>

<style scoped>
.pagination {
	margin-bottom: 0;
}

.bg-info {
	background-color: #061f3f;
}

.pay_load {
	z-index: 5;
	position: absolute;
	width: 98%;
	height: 100%;
	border-radius: 10px;
	background: #204d83cc;
}

.load_pay {

	position: fixed;
	display: block;
	top: 20%;
	transform: translateY(-20%);
	left: 50%;
	transform: translateX(-50%);
}
</style>
